import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthQuery } from '../auth-http-client';
import { accountTreeNodeSchema } from '../types';

export type GetAccountTreeParams = {
	name?: string;
	currencies?: string[];
};

export const getAccountTreeQuery = createAuthQuery({
	params: declareParams<GetAccountTreeParams>(),
	request: {
		method: 'GET',
		url: '/account/tree',
		query: (data) => data,
	},
	response: {
		contract: zodContract(accountTreeNodeSchema.array()),
	},
});
